import { useEffect, useMemo } from "react";
import { useVisit } from "../../../context/VisitProvider";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function Tracker({ children, moduleName }) {
  const location = useLocation();
  const { setModuleVisits } = useVisit();
  const { module } = useParams();
  const { subject, chapter, topic } = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);
    return ["subject", "chapter", "topic"].reduce((prev, curr) => {
      if (searchParams.get(curr)) {
        prev[curr] = searchParams.get(curr);
      }
      console.log(prev);
      return prev;
    }, {});
  }, []);

  useEffect(() => {
    if (moduleName) {
      // Initialize visit if not already stored

      const [grade, section] = localStorage.getItem("userGrade").split("-");

      setModuleVisits({
        teacherId: window.localStorage.getItem("userId") || "unknown",
        moduleId: module,
        module: moduleName,
        subject,
        chapter,
        topic,
        grade,
        section,
      });

      // Interval: update `updatedOn` every 2 seconds
      const interval = setInterval(() => {
        const key = "visit:page";
        const raw = window.localStorage.getItem(key);
        if (!raw) return;

        const visits = JSON.parse(raw);
        if (visits[module]) {
          visits[module].updatedOn = Date.now();
          window.localStorage.setItem(key, JSON.stringify(visits));
        }
      }, 2000);

      return () => clearInterval(interval); // cleanup when leaving page
    }
  }, [location.pathname, setModuleVisits, moduleName]);

  return <div>{children}</div>;
}
